import {Circle, HStack, forwardRef} from '@chakra-ui/react';
import type {FC, ComponentType, PropsWithRef} from 'react';
import type {Props as LegendProps} from 'recharts/types/component/DefaultLegendContent';

import {Text} from '../index';

export const toSentenceCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

type Props = PropsWithRef<LegendProps>;

const ChartLegend: FC<Props> = forwardRef<LegendProps, ComponentType<typeof HStack>>(({payload}, ref) => {
  // TODO: consume filter from props
  // TODO: fix payload type
  const filteredPayload = payload?.filter(p => (!p as any).dataKey.includes(`gap`));
  return (
    <HStack ref={ref}>
      {filteredPayload?.map((entry, index) => {
        return (
          <HStack key={`legend-${index}`} spacing={`8`} style={{justifyContent: `flex-end`}}>
            <Circle background={entry.color} size={`2`} />
            <Text variant={`secondary`}>{toSentenceCase(entry.value)}</Text>
          </HStack>
        );
      })}
    </HStack>
  );
});

export default ChartLegend;
export type {Props as ChartLegendProps};
